import React, { Component } from 'react';
import { Form } from 'react-form';
import uuidv1 from 'uuid/v1';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import { Input } from 'react-chat-elements';
import Dialog from '../UI/Dialog';
import { getChatUsers, getConversation, sendMessage, changeChatStatus } from '../../store/actions';
import Collapsible from 'react-collapsible';
import moment from 'moment';


class LiveChat extends Component {
    state = {
        user: null,
        isCompleteDialogOpen: false,
        currentUserConversationId: null,
        searchValue: ''
    };

    componentDidMount() {
        this.props.getChatUsers();
    }

    sendMessage = () => {
        if(!this.refs.input.state.value) return;
        const uuid = uuidv1();
        const date = new Date();
        const data =  {
            adminSeen: true,
            fromUser: false,
            message: this.refs.input.state.value,
            timestamp: moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        };
        this.props.sendMessage(this.state.user.conversation, data, uuid, this.state.currentUserConversationId);
        this.refs.input.clear();
    };

    onCompleteConversation = () => {
        this.props.changeChatStatus(this.state.currentUserConversationId);
        this.setState({isCompleteDialogOpen: false, user: {...this.state.user, status: 'closed'}});
    };

    renderConversation() {
        if (!this.props.conversation) return null;
        const convs = [];
        for (const key in this.props.conversation) {
            convs.push({ id: key, ...this.props.conversation[key]})
        }
        convs.sort((a, b) => {
            const adate = new Date(a.timestamp );
            const bdate = new Date(b.timestamp );
            // console.log('adate: ', adate);
            // console.log('bdate: ', bdate);
            // console.log('adate.getTime: ', adate.getTime());
            // console.log('bdate.getTime: ', bdate.getTime());
            return adate.getTime() - bdate.getTime();
        });
        const chat = convs.map(conv => {
            return (
                <li key={ conv.id } className={"msg-row " + (conv.fromUser ? "receiver": "sender")}>
                    <div className="msg-inner">
                        {conv.fromUser ? <span className="avatar">JD</span> : null }
                        <div className="msg">{conv.message}</div>
                        {/*{conv.fromUser && <span className="new-msg-ntf"></span>}*/}
                    </div>
                    <div className="msg-meta">
                        <span>{ moment(conv.timestamp).format('MMMM Do YYYY, h:mm:ss a') }</span>
                    </div>
                </li>
            );
        });

        return chat;
    }

    onSearchHandler(e) {
        this.setState({ searchValue: e.target.value });
    };

    onUserClickHandler = (user, conversationId, chatUsers) => {
        this.setState({currentMessage: ''});
        if (this.refs.input) this.refs.input.clear();
        this.props.getConversation(user.conversation);
        const currentUser = {...user};
        this.setState({ user: currentUser, currentUserConversationId: conversationId });
    };

    getFirstLetters = value => value ? value.substr(0, 2).toUpperCase() : '';

    renderUsers() {
        const { chatUsers } = this.props;
        if (!chatUsers) return null;
        let usersId = [];
        let usersObj = [];
        for (const key in chatUsers) {
            const id = chatUsers[key].user_id;
            if (usersId.indexOf(id) === -1) {
                usersId.push(id);
                usersObj.push({ [id]: [key] });
            } else {
               const index = usersObj.findIndex(obj => obj.hasOwnProperty(id));
                usersObj[index][id].push(key);
            }
        }
        const users = usersObj.map(userObj => {
            const id = Object.keys(userObj)[0];
            let pending = false;
            for (const chatUserId of userObj[id]) {
                if(chatUsers[chatUserId].status === 'opened') {
                    pending = true;
                    break;
                }
            }
            const userData = chatUsers[userObj[id][0]];
            let name = userData.first_name + userData.last_name;
            if (!name) {
                name = ''
            }
            if(name.indexOf(this.state.searchValue) === -1) return null;
            const userName = this.getFirstLetters(userData.first_name);
            const user = (
                <a>
                    <div className="flex align-center">
                        <span className="avatar">{ userName }</span>
                        <div className="pl-15 contact-name">
                            <p className="font-sm w-700 ellipsis">{ userData.first_name }</p>
                        </div>
                        { pending && <span className="pending tag-style ml-10 xs red">pending</span> }
                    </div>
                    <div className="px-20">
                        <div className="w-700 font-sm id-number">
                            <span className="color-grey50">ID: </span>
                            <span>{id}</span>
                        </div>
                    </div>
                </a>
            );
            const conversations = userObj[id].map(conversationId => {
                const lastMessage = chatUsers[conversationId].last_message;
                const timestamp = chatUsers[conversationId].last_message_timestamp;
                const isPending = chatUsers[conversationId].status === 'opened';
                return (
                    <li className={ this.state.user && chatUsers[conversationId].conversation === this.state.user.conversation ? "active": "" }
                        key={ conversationId }
                        onClick={ () => this.onUserClickHandler(chatUsers[conversationId], conversationId, chatUsers) } >
                        <a>
                            <div className="flex align-center">
                                <span className="avatar small">{ userName }</span>
                                <div className="pl-15 contact-name">
                                    <p className="font-sm w-700 ellipsis">{ lastMessage }</p>
                                    <p className="font-xs w-600 color-grey50">{ timestamp && moment(timestamp).format('MMMM Do YYYY, h:mm:ss a') }</p>
                                </div>
                                { isPending && <span className="pending tag-style ml-10 xs red">pending</span> }
                            </div>
                            <div className="flex align-center justify-end">
                                {/*<span className="notification">99+</span>*/}
                                <div className="w-700 font-sm">
                                    <span className="color-grey50">ID: </span>
                                    <span>{ id }</span>
                                </div>
                            </div>
                        </a>
                    </li>
                );
            });

            return (
                <li key={ id }>
                    <Collapsible trigger={ user } transitionTime={200}>
                        <ul className="dropdown-inner">
                            { conversations }
                        </ul>
                    </Collapsible>
                </li>
            );

        });
        return users;
    }

    render() {
        return (
            <React.Fragment>
                <div className="container pt-35 pb-35">
                    <div className="messages row">
                        <div className="message-sidebar col-xs-4 px-0">
                            <div className="message-header">
                                <p>Messages</p>
                            </div>

                            {/*hide when no messages*/}
                            { this.props.chatUsers && <div className="sidebar-inner">
                                <div className="search-bar">
                                    <div className="input-style">
                                        <input type="text" placeholder="Search" onChange={this.onSearchHandler.bind(this) }/>
                                        <i className="fa fa-search font-md mr-15"></i>
                                    </div>
                                </div>
                                <div className="contacts">
                                    <Scrollbars renderThumbHorizontal={ () => <div></div> }
                                                style={{ maxWidth: "100%" }} >
                                        <ul className="contact-list">
                                            { this.renderUsers() }
                                        </ul>
                                    </Scrollbars>
                                </div>

                            </div> }
                            {/*hide when no messages*/}

                            {/*show when no messages*/}
                            {!this.props.chatUsers && <div className="placeholder-text">
                                <i className="fa  fa fa-users"></i>
                                <h2>Hi { this.props.adminName }</h2>
                                <p>You have no conversation with the Users yet</p>
                            </div> }
                            {/*show when no messages*/}

                        </div>
                        <div className="chat-section col-xs-8 px-0">
                            <div className="message-header">

                                <div className="flex align-center">
                                    <p className="mr-30">
                                        { this.state.user ? `${this.state.user.first_name} ${this.state.user.last_name}`: null}
                                     </p>
                                    <div>
                                        { this.state.user && <span className="color-grey50">ID: </span> }
                                        { this.state.user && <span>{ this.state.user.user_id }</span>}
                                    </div>
                                </div>

                                <div className="flex align-center">
                                    { this.state.user && this.state.user.status === 'opened' && <button onClick={ () => this.setState({ isCompleteDialogOpen: true }) } className="btn filled small min-120 primary">
                                        Complete
                                    </button>}
                                </div>
                            </div>
                            { this.props.conversation && <div className="chat-area">
                                <Scrollbars style={{ maxWidth: "100%" }} >
                                    <div className="chat-area-inner">
                                        <ul>
                                            { this.renderConversation() }

                                            {/*<li className="date-divider">*/}
                                                {/*<p><span>05 May 2018</span></p>*/}
                                            {/*</li>*/}

                                        </ul>
                                    </div>
                                </Scrollbars>
                            </div>}

                            { !this.props.conversation && <div className="chat-area">
                                <div className="placeholder-text">
                                    <i className="fa  fa-comments"></i>
                                    <h2>Hi { this.props.adminName }</h2>
                                    <p>You have no messages</p>
                                </div>
                            </div>}

                            <div className="typing-area">
                                {this.props.conversation && this.state.user && this.state.user.status === 'opened' && <Input
                                    className="textarea"
                                    ref='input'
                                    onChange={ e => this.setState({currentMessage: e.target.value}) }
                                    inputStyle={{backgroundColor: 'transparent', height: '40px'}}
                                    placeholder="Type your message here"
                                    multiline={true}
                                    rightButtons={
                                        <button onKeyUp={e => e.keyCode === 13 ? this.sendMessage(): null} className="no-style font-lg" onClick={this.sendMessage}>
                                            <i className="fa fa-paper-plane" aria-hidden="true"></i>
                                        </button>
                                    } />}
                            </div>

                        </div>
                    </div>
                </div>

                <Dialog open={this.state.isCompleteDialogOpen} handleClose={ () => this.setState({ isCompleteDialogOpen: false }) }>
                    <Form onSubmit={ () => this.onCompleteConversation() }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Are you sure you want to complete this conversation?</h2>
                                </div>

                                <div className="popup-meta flex justify-end">
                                    <button className="no-style w-600 pointer mx-20" type="button"
                                            onClick={ () => this.setState({ isCompleteDialogOpen: false }) }>
                                        No
                                    </button>
                                    <button type="submit" className="btn filled primary min-120">Yes</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isCompleteDialogOpen: false }) }>×</button>
                </Dialog>
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        chatUsers: state.livechat.chatUsers,
        conversation: state.livechat.conversation,
        adminName: state.auth.adminName
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getChatUsers: () => dispatch( getChatUsers() ),
        getConversation: (id) => dispatch( getConversation(id) ),
        sendMessage: (id, data, uuid, currentUserConversationId) => dispatch( sendMessage(id, data, uuid, currentUserConversationId) ),
        changeChatStatus: (id) => dispatch( changeChatStatus(id) )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( LiveChat );



// WEBPACK FOOTER //
// ./src/components/Live-chat/LiveChat.js